import { render, staticRenderFns } from "./NewsMain.vue?vue&type=template&id=d8418d36"
import script from "./NewsMain.vue?vue&type=script&lang=ts"
export * from "./NewsMain.vue?vue&type=script&lang=ts"
import style0 from "./NewsMain.vue?vue&type=style&index=0&id=d8418d36&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports